import { Component, OnDestroy, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { MomentDateAdapter } from '@angular/material-moment-adapter';
import { ActivatedRoute, Router } from '@angular/router';
import { SnackbarService } from '../../../_service/message-service';
import { RfidServiceService } from 'src/app/_service/rfid-service.service';
import { UserService } from 'src/app/_services';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';
import { ActualRole, Role } from '../../../util/enums/role.enum';
import { UserInfoService } from 'src/app/_services/userInfo.service';
import { UserTypes } from 'src/app/shared/interfaces/userType.model';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import { MatDialog } from '@angular/material/dialog';
export const MY_FORMATS = {
  parse: {
    dateInput: 'LL',
  },
  display: {
    dateInput: 'YYYY-MM-DD',
    monthYearLabel: 'YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'YYYY',
  },
};

@Component({
  selector: 'telio-rfid-create',
  templateUrl: './rfid-create.component.html',
  styleUrls: ['./rfid-create.component.scss'],
  providers: [
    { provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE] },
    { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS },
  ],

})
export class RfidCreateComponent implements OnInit,OnDestroy {
  rfidSubscription = new Subscription()
  createRfid: UntypedFormGroup;
  minDate;
  enableMasterRfid = false;
  masterRfidList = [];
  disableSelect = new UntypedFormControl(false);
  search;
  userDetails;
  cookieDetails;
  searchForUser;
  showNoData = false;
  showMasterCardList = true;
  alphaNumeric: RegExp = /^[a-zA-Z0-9]*$/;
  position = 1;
  hideMasterTag = false;
  alphaNumericWithSpecialChars: RegExp = /^[a-zA-Z0-9#,:$\-/@_. ]*$/;
  mobileNumbers: RegExp = /^[1-9]\d{7,9}$/gi;
  emailRegEX: RegExp = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@,"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/

  @ViewChild('searchAlert', { static: false }) searchAlert: TemplateRef<any>;

  constructor(private formBuilder: UntypedFormBuilder,
    private userService: UserService,
    private rfidService: RfidServiceService,
    private userInfoService: UserInfoService,
    private router: Router,
    private toastr: SnackbarService,
    readonly route: ActivatedRoute,
    public translate: TranslateService,
    public dialog: MatDialog) { }

  ngOnInit() {
    var nextyearDate = new Date();
    nextyearDate.setDate(nextyearDate.getDate() + 364);
    this.minDate = new Date();
    this.rfidSubscription.add(this.rfidService.getMasterCards().subscribe(resp => {
      this.masterRfidList = resp.content;
    },
    error => {
      this.toastr.error(error.message)
    }))
    this.createRfid = this.formBuilder.group({
      rfid_tag: [null, Validators.compose([
        Validators.required, Validators.pattern(this.alphaNumericWithSpecialChars)
      ])],
      user_id: [null, Validators.compose([
      ])],
      user_name: [null, Validators.compose([
      ])],
      expiration_date: [nextyearDate, Validators.required],
      master_rfid: [null],
      comment: [null, Validators.compose([
        Validators.required])]
    });
    this.cookieDetails = this.userInfoService.userDetails;
  }

  refuseInvalid(event) {
    if (event.type == 'input' || event.type == 'paste') {
      event.preventDefault()
      return false;
    }
  }

  showOptions(event) {
    if (event.checked) {
      this.createRfid.controls['master_rfid'].reset();
      this.showMasterCardList = false;
      this.position = 0;
    }
    else {
      this.showMasterCardList = true;
      this.position = 1;
    }
  }

  resetmethod() {
    this.userDetails = [];
    this.enableMasterRfid = true;
    this.showMasterCardList = true;
    this.createRfid.reset();
  }

  onSubmit() {
    if (this.showMasterCardList) {
      if (!this.createRfid.get('master_rfid').value) {
        this.toastr.error(this.translate.instant('rfid.masterError'))
        return;
      }
    }
    let input = {
      "id_tag": this.createRfid.value.rfid_tag,
      "user_id": this.createRfid.value.user_id,
      "status": "Activated",
      "expired_date": this.createRfid.value.expiration_date,
      "created_date": new Date(),
      "created_by_id": this.cookieDetails.userId,
      "created_by_name": this.cookieDetails.username,
      "updated_date": new Date(),
      "updated_by": this.userInfoService.groups.find(role => role === Role.CPO || role === Role.SUPERADMIN || role === Role.ADMIN),
      "comments": this.createRfid.value.comment,
      "position": this.position,
      "owner": this.userInfoService.groups.find(role => role === Role.CPO || role === Role.SUPERADMIN || role === Role.ADMIN || role === Role.SUBCPO || role === Role.OPERATOR || role === Role.STATIONMANAGER)|| this.userInfoService.userDetails.groups[0],
      "master_rfid_card": this.createRfid.value.master_rfid,
    }
    this.rfidSubscription.add(this.rfidService.createRfidCard(input).subscribe(resp => {
      if (!!resp) {
        this.toastr.success(this.translate.instant('rfid.successCreate'));
        this.router.navigate(['//dashboard/rfid', { routeID: this.route.snapshot.paramMap.get('routeID') }]);
      }
    },
      error => {
        this.toastr.error(error.message);
      })
    )
  }

  openDialog() {
    let dialogRef = this.dialog.open(this.searchAlert, {
      height: '500px',
      width: '800px'
    }).afterClosed().subscribe((res: any) => {
    })
  }

  searchUser() {
    let searchval = this.search.charAt(0);
    let hasNumber = /\d/;
    if (hasNumber.test(searchval)) {
      if (this.search.match(this.mobileNumbers)) {
        this.searchForUser = this.search
        this.getDetailsbySearch()
      }
      else {
        this.toastr.error(this.translate.instant('rfid.mobileError'))
        return
      }
    }
    else {
      if (this.emailRegEX.test(this.search)) {
        this.searchForUser = this.search
        this.getDetailsbySearch()
      }
      else {
        this.toastr.error(this.translate.instant('rfid.emailError'))
        return
      }
    }
  }

  getDetailsbySearch() {
    this.userService.getAllUsers(1, 10, 'username', 'asc', this.searchForUser, UserTypes.mobileUsers).subscribe(
      resp => {
        this.userDetails = resp.data.content[0].user;
        if (this.userDetails) {
          this.showNoData = false;
          this.userDetails.mobile = this.userDetails.mobile == 0 ? '' : this.userDetails.mobile;
          if (this.userDetails.email == "" || this.userDetails.email == undefined) {
            this.userDetails.email = "Not Available"
          }
        }
        else {
          this.showNoData = true;
        }

      }
    )
  }

  selectUser() {
    this.createRfid.controls.user_name.setValue(this.userDetails.username);
    this.createRfid.controls.user_id.setValue(this.userDetails.userId);
    this.dialog.closeAll();
    this.userDetails = undefined;
    this.search = '';
  }

  closePopup() {
    this.dialog.closeAll();
    this.userDetails = undefined;
    this.search = '';
  }

  back() {
    this.router.navigate(["/dashboard/rfid", { routeID: this.route.snapshot.paramMap.get('routeID') }])
  }

  ngOnDestroy() {
    this.rfidSubscription && this.rfidSubscription.unsubscribe();
  }
}
